export default __webpack_public_path__ + "static/media/ci-icon.929e7dd8.svg";